import { CommonModule as AngularCommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgLetModule } from 'src/directives/ngLet';
import { ExternalRedirectDirective } from '../../directives/externalRedirect';
import { ExternalRedirectWithHref } from '../../directives/externalRedirectWithHref';
import { BtnCallToActionComponent } from './btn-call-to-action/btn-call-to-action.component';
import { BtnOutlineComponent } from './btn-outline/btn-outline.component';
import { CookiesConsentComponent } from './cookies-consent/cookies-consent.component';
import { CurrentStatusEventsComponent } from './current-status-events/current-status-events.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { LogoComponent } from './logo/logo.component';
import { OfferCardComponent } from './offer-card/offer-card.component';
import { PageComponent } from './page/page.component';

const components = [
	ExternalRedirectDirective,
	ExternalRedirectWithHref,
	LanguageSwitcherComponent,
	LogoComponent,
	HeaderComponent,
	FooterComponent,
	PageComponent,
	BtnCallToActionComponent,
	BtnOutlineComponent,
	CookiesConsentComponent,
	OfferCardComponent,
	CurrentStatusEventsComponent,
];

@NgModule({
	imports: [
		AngularCommonModule,
		NgLetModule,
		RouterModule,
		TranslateModule.forChild(),
		ReactiveFormsModule,
		NgbCollapseModule,
		HttpClientModule,
		NgbModule,
	],
	declarations: [...components],
	exports: [...components],
})
export class CommonModule {}
